(function () {

  /* ---------------------------------------------------------
     FLOATING MENU SECTION (CATEGORY REMOVED)
  ---------------------------------------------------------- */

  class FloatingMenu extends HTMLElement {
    constructor() {
      super();
      this.state = { activePanel: null };
      this.lastActive = null;

      /* ⭐ SAFE requestIdleCallback fallback (No errors) */
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(() => {
          this.attachEventListeners();
          this.setupResizeObserver();
        });
      } else {
        setTimeout(() => {
          this.attachEventListeners();
          this.setupResizeObserver();
        }, 1);
      }
    }

    connectedCallback() {
      document.body.classList.add("has-floating-menu");

      // Indicator create if missing
      if (!this.querySelector(".nav-indicator")) {
        const indicator = document.createElement("span");
        indicator.className = "nav-indicator";
        indicator.style.cssText =
          "position:absolute;bottom:0;height:2px;width:0;transition:transform .25s,width .25s,opacity .25s;background:currentColor;opacity:0;";
        this.appendChild(indicator);
      }

      const nav = document.querySelector(".floating-nav");
      if (nav) {
        document.documentElement.style.setProperty("--floating-menu-height", nav.offsetHeight + "px");
        document.documentElement.style.paddingBottom = "var(--floating-menu-height)";
      }

      this.setInitialActiveNav();
    }

    attachEventListeners() {
      this.addEventListener("click", this.handleClick.bind(this));
      document.addEventListener("keydown", this.handleKeyDown.bind(this));

      /* CART DRAWER CLOSE FIX */
      document.body.addEventListener("click", (event) => {
        const closeBtn = event.target.closest(".kymee-drawer__close");
        if (!closeBtn) return;

        const cartDrawer = document.querySelector(".kymee-drawer");
        if (cartDrawer) {
          cartDrawer.classList.remove("is-open"); // 🔥 MAIN FIX
        }

        document.body.style.overflow = "";
        document.body.classList.remove("overflow-hidden", "overflow-hidden-tablet");

        this.state.activePanel = null;
        this.restoreAfterDrawer();
        this.setInitialActiveNav();
      });


      /* CATEGORY DRAWER CLOSE FIX */
      document.body.addEventListener("click", (event) => {
        const closeBtn = event.target.closest(".category-drawer .drawer-close");
        if (!closeBtn) return;

        document.body.style.overflow = "";
        document.body.classList.remove("overflow-hidden", "overflow-hidden-tablet");

        // safety reset
        this.state.activePanel = null;
        this.restoreAfterDrawer();
        this.setInitialActiveNav();
      });


      this.updateCartCount();
      this.cartInterval = setInterval(this.updateCartCount.bind(this), 10000);
    }

    disconnectedCallback() {
      clearInterval(this.cartInterval);
    }

    setupResizeObserver() {
      if ("ResizeObserver" in window) {
        const ro = new ResizeObserver(() => {
          if (this.state.activePanel) this.positionPanel();
        });
        ro.observe(document.body);
      }
    }

    getPageState() {
      const path = window.location.pathname;
      return {
        isHome: path === "/" || path === "/index"
      };
    }

    /* -------------------------------------------
       MAIN CLICK HANDLER
    ------------------------------------------- */
    handleClick(event) {
      const target = event.target.closest("[data-nav], [data-action]");
      if (!target) return;

      const panel = target.dataset.nav;
      const action = target.dataset.action;
      const indicator = this.querySelector(".nav-indicator");
      const home = this.querySelector('.nav-item[data-nav="home"]');

      /* HOME button on home page */
      if (panel === "home" && this.getPageState().isHome) {
        event.preventDefault();
        this.closePanel();
        this.restoreTo(home);
        return;
      }

      /* CLOSE */
      if (action === "close") {
        this.closePanel();
        return;
      }

      /* ⭐ CART BUTTON → Always open drawer (no redirect) */
      if (panel === "cart") {
        event.preventDefault();
        this.closePanel();

        const cartDrawer = document.querySelector(".kymee-drawer");
        if (cartDrawer) {
          cartDrawer.classList.add("is-open");
          document.body.classList.add("overflow-hidden");
        }

        this.updateActiveState(target);
        return;
      }

      /* SEARCH Drawer */
      /* SEARCH Drawer */
      if (panel === "search") {
        event.preventDefault();
        this.closePanel();

        const searchDrawer = document.querySelector(".header__search details");
        if (searchDrawer) {
          searchDrawer.setAttribute("open", "true");
          document.body.classList.add("overflow-hidden");

          // 🔥 AUTO FOCUS + TYPE START
          requestAnimationFrame(() => {
            const searchInput = searchDrawer.querySelector('.search__input.field__input');
            if (searchInput) {
              searchInput.focus();
              searchInput.click(); // iOS / Safari safety
            }
          });
        }
        return;
      }


      /* Other nav items */
      this.updateActiveState(target);
    }

    handleKeyDown(event) {
      if (event.key === "Escape") this.closePanel();
    }

    togglePanel(panel) {
      this.state.activePanel === panel ? this.closePanel() : this.openPanel(panel);
    }

    openPanel(panel) {
      this.closePanel();
      this.state.activePanel = panel;

      const el = document.getElementById(`${panel.charAt(0).toUpperCase() + panel.slice(1)}Drawer`);
      if (el) {
        el.classList.add("active");
        el.removeAttribute("aria-hidden");
        document.body.style.overflow = "hidden";
      }
    }

    closePanel() {
      if (!this.state.activePanel) return;

      const panel = this.state.activePanel;
      const el = document.getElementById(`${panel.charAt(0).toUpperCase() + panel.slice(1)}Drawer`);

      if (el) {
        el.classList.remove("active");
        el.setAttribute("aria-hidden", "true");
      }

      this.restoreAfterDrawer();
      this.state.activePanel = null;
      document.body.style.overflow = "";
      document.body.classList.remove("overflow-hidden", "overflow-hidden-tablet");
    }

    restoreAfterDrawer() {
      const indicator = this.querySelector(".nav-indicator");
      const { isHome } = this.getPageState();

      this.clearActive();

      if (isHome) {
        const h = this.querySelector('.nav-item[data-nav="home"]');
        h.classList.add("active");
        this.moveIndicator(h, indicator);
        indicator.style.opacity = "1";
      } else {
        indicator.style.opacity = "0";
      }
    }

    clearActive() {
      this.querySelectorAll(".nav-item[data-nav]").forEach((i) => i.classList.remove("active"));
    }

    restoreTo(item) {
      const indicator = this.querySelector(".nav-indicator");
      this.clearActive();
      item.classList.add("active");
      indicator.style.opacity = "1";
      this.moveIndicator(item, indicator);
    }

    setInitialActiveNav() {
      const indicator = this.querySelector(".nav-indicator");
      const home = this.querySelector('.nav-item[data-nav="home"]');

      const { isHome } = this.getPageState();

      indicator.style.opacity = "0";

      setTimeout(() => {
        if (isHome) {
          home.classList.add("active");
          indicator.style.opacity = "1";
          this.moveIndicator(home, indicator);
        }
      }, 80);
    }

    updateActiveState(clickedItem) {
      const indicator = this.querySelector(".nav-indicator");
      this.clearActive();
      clickedItem.classList.add("active");
      indicator.style.opacity = "1";
      this.moveIndicator(clickedItem, indicator);
    }

    moveIndicator(item, indicator) {
      const navRect = this.querySelector(".floating-nav").getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const offset = itemRect.left - navRect.left + itemRect.width / 2 - indicator.offsetWidth / 2;

      indicator.style.transform = `translateX(${offset}px)`;
    }

    positionPanel() {
      if (!this.state.activePanel) return;
      const el = document.getElementById(`${this.state.activePanel.charAt(0).toUpperCase() + this.state.activePanel.slice(1)}Drawer`);
      if (el) el.offsetHeight; // force paint
    }

    updateCartCount() {
      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => {
          const count = cart.item_count;
          document.querySelectorAll("[data-cart-count]").forEach((el) => {
            el.textContent = count;
            el.classList.toggle("show", count > 0);
          });
        })
        .catch(() => { });
    }
  }

  if (!customElements.get("floating-menu")) {
    customElements.define("floating-menu", FloatingMenu);
  }
}

)();
